interface EnvConfig {
  supabaseUrl: string
  supabaseAnonKey: string
  geminiApiKey: string
  stripePublishableKey: string
}

let cachedEnv: EnvConfig | null = null

function validateEnv(): EnvConfig {
  if (cachedEnv) {
    return cachedEnv
  }

  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
  const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY
  const geminiApiKey = import.meta.env.VITE_GEMINI_API_KEY
  const stripePublishableKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || ''

  const missingVars: string[] = []

  if (!supabaseUrl) missingVars.push('VITE_SUPABASE_URL')
  if (!supabaseAnonKey) missingVars.push('VITE_SUPABASE_ANON_KEY')
  if (!geminiApiKey) missingVars.push('VITE_GEMINI_API_KEY')

  if (missingVars.length > 0) {
    throw new Error(
      `Missing required environment variables: ${missingVars.join(', ')}. ` +
      'Please check your .env file.'
    )
  }

  cachedEnv = {
    supabaseUrl,
    supabaseAnonKey,
    geminiApiKey,
    stripePublishableKey
  }

  return cachedEnv
}

export function getEnv(): EnvConfig {
  return validateEnv()
}

export const env = new Proxy({} as EnvConfig, {
  get(target, prop) {
    const config = validateEnv()
    return config[prop as keyof EnvConfig]
  }
})
